<template>
<div class="chapter">
<div class="inner_page">
<div id="V4039_ebook.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN" id="toc_marker-1"><span class="char-style-override-1"><img alt="9780802126108.jpg" class="image" height="648" src="images/9780802126108_fmt.png" width="426"/></span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4039_ebook.vue?7674529b